import React from 'react'
import { FormattedMessage } from 'react-intl';
 
function ImportModal(props) {
  const { 
    success,
    error,
    uploadFile,
    companies,
    selectedCompanyImport, setSelectedCompanyImport,
    importFile, setImportFile
  } = props;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setImportFile(selectedFile);
  };

  return (
    <div className="modal fade" id="importModal" tabIndex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
              <h5 className="modal-title"><FormattedMessage id="IMPORT_RECEIVERS" /></h5>
            <button type="button" id="btn-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="userField row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="validateFirstName" className="col-form-label mx-1" style={{ fontSize: '18px' }}>
                    <FormattedMessage id="Companies" />
                  </label>
                  <select
                    className="form-control"
                    value={selectedCompanyImport}
                    id="validateFirstName"
                    onChange={(e) => setSelectedCompanyImport(e.target.value)}
                    required
                  >
                    <option value="" disabled className="default-option">
                      <FormattedMessage id="SELECT_A_COMPANY" />
                    </option>
                    {companies.map((company, index) => (
                      <option key={index} value={company.id}>
                        {company.company_name}
                      </option>
                    ))}
                  </select>
                  <div className="valid-feedback">
                    <FormattedMessage id="FEEDBACK_LOOKS_GOOD" />
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <input className="form-control" type="file" id="userFormFile"/>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn save-btn mx-auto" onClick={uploadFile}>
              <FormattedMessage id="IMPORT" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImportModal